import { Instance } from 'mobx-state-tree';
import { SolutionUnscheduledDtoModelBase } from './SolutionUnscheduledDtoModel.base';

/* The TypeScript type of an instance of SolutionUnscheduledDtoModel */
export interface SolutionUnscheduledDtoModelType extends Instance<typeof SolutionUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for SolutionUnscheduledDtoModel */
export { selectFromSolutionUnscheduledDto, solutionUnscheduledDtoModelPrimitives, SolutionUnscheduledDtoModelSelector } from './SolutionUnscheduledDtoModel.base';

/**
 * SolutionUnscheduledDtoModel
 */
export const SolutionUnscheduledDtoModel = SolutionUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
